// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1XxCe","button-heading":"styles_button-heading__3b3IP","image":"styles_image__19HKG","gradient":"styles_gradient__3gicJ"};